import { COACH_PATH } from '@/features/coach/constants';

export const COACH_INTERVIEW_PATH = `${COACH_PATH}/interview`;
